<template>
  <div :class="['app', { 'no-scroll': noScroll }]" id="app">
    <sticky-event
      v-if="displayBanner"
      ref="stickyBanner"
      @mounted="onStickyMounted"
    />
    <div class="app-container">
      <site-header />
      <router-view />
      <site-footer />

      <installation
        v-if="!installationOff && platform"
        :platform="platform"
        :deferredPrompt="deferredPrompt"
        @close="onInstallationClose"
        @install="install"
      />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/partials/Header.vue';
import SiteFooter from '@/components/partials/Footer.vue';
import StickyEvent from '@/components/partials/StickyEvent.vue';
import Installation from '@/components/partials/Installation.vue';

export default {
  components: {
    SiteHeader,
    SiteFooter,
    StickyEvent,
    Installation
  },
  beforeMount() {
    // this.$store.dispatch('landing/setDate');
    // this.$store.dispatch('landing/updateTimer');

    const profile = localStorage.getItem('profile-data');

    if (profile) {
      this.$store.commit('profile/updateInfos', JSON.parse(profile));
      this.$store.commit('login/setLogged', true);
      this.$store.dispatch('profile/getOrders');

      if (this.$route.name === 'Login') {
        this.$router.push({ name: 'Profile' });
      }
    }

    if (this.$store.state.banner.item === null) {
      this.$store.dispatch('banner/get');
    }

    this.$store.dispatch('profile/checkUserPref');
  },
  created() {
    const installationOff = localStorage.getItem('installation-off');
    if (!installationOff || installationOff !== 'true') {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        // console.log('in webapp');
        return;
      }

      // if (navigator.getInstalledRelatedApps) {
      //   const relatedApps = await navigator.getInstalledRelatedApps();
      //   console.log('relatedApps :', relatedApps);
      //   relatedApps.forEach((app) => {
      //     console.log('app :', app.id, app.platform, app.url);
      //   });
      // }

      this.installationOff = false;
      this.setPlatform();

      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
      });
      window.addEventListener('appinstalled', () => {
        this.deferredPrompt = null;
        this.onInstallationClose();
      });
    }
  },
  data() {
    return {
      installationOff: true,
      platform: null,
      beforeinstallprompt: this.onInstallationClose.bind(this),
      deferredPrompt: null
    };
  },
  computed: {
    displayBanner() {
      return this.$store.state.banner.display && this.$store.state.banner.requests === 0;
    },
    noScroll() {
      return this.$route.name === 'Orders' && this.$store.state.profile.orders.ticket;
    }
  },
  methods: {
    onStickyMounted() {
      setTimeout(() => {
        this.setBannerHeight();
      }, 300);
    },
    setBannerHeight() {
      if (!this.$refs.stickyBanner) {
        this.$store.commit('banner/setBannerHeight', 0);
        return;
      }

      const { height } = this.$refs.stickyBanner.$el.getBoundingClientRect();
      this.$store.commit('banner/setBannerHeight', height);
    },
    onInstallationClose() {
      this.deferredPrompt = null;
      this.installationOff = true;
      localStorage.setItem('installation-off', 'true');
    },
    install() {
      this.deferredPrompt.prompt();
    },
    setPlatform() {
      const ua = window.navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

      if (iOS) {
        if (iOSSafari) {
          this.platform = 'ios';
        }

        return;
      }

      if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
        this.platform = 'android';
      }
    }
  }
};
</script>

<style lang="scss">
@import 'scss/reset';
@import 'scss/fonts';
@import 'scss/utils';
@import 'scss/typeset';

body {
  @include size(100%, auto);
  @include font('primary', 'regular');
  min-height: 100vh;
  background-color: $black;
  color: $white;
  font-size: rem(14px);
  line-height: 1.5;
}

.container {
  @include margin(null auto);
  @include padding(null $gs-padding);
  width: 100%;
  max-width: $gs-container;
}

.app {
  &.no-scroll {
    height: 100vh;
    overflow: hidden;
  }

  &-container {
    @include margin(null auto);
    width: 100%;
    max-width: $gs-container;
    min-height: 100vh;
    overflow: hidden;
    padding-bottom: 68px;
  }

  .view {
    min-height: calc(100vh - 68px);
    padding-top: 50px;
  }
}

// Typo
.h1 {
  color: $white;
  font-size: rem(32px);
  line-height: (38 / 32);
}

.h2 {
  @include font('primary', 'bold');
  font-size: rem(24px);
  line-height: (29 / 24);
}

.h3 {
  font-size: rem(22px);
  line-height: (26 / 24);
}

.headline {
  color: rgba($white, .8);
  font-size: rem(14px);
  line-height: 1;
}

.label {
  @include padding(4px 8px);
  @include font('secondary', 'regular');
  border: 1px solid $grey-light-alternate;
  border-radius: 3px;
  background-color: $white;
  color: $primary;
  font-size: rem(16px);
  line-height: (18 / 16);
}
</style>
